
import { RevButton } from '@ds/components/Button'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import isEmpty from 'lodash/isEmpty'

import ProductThumb from '@landing/components/ProductThumb'
import {
  PRODUCT_DEAL_TYPE,
  PRODUCT_DEFAULT_SHIPPING_COST,
  PRODUCT_PROVIDERS,
  PRODUCT_SOURCE,
} from '@tracking'

import {
  concatResultHits,
  findResultsFromMultipleQueries,
} from '../../helpers/algolia'
import algoliaTranslations from '../../helpers/algolia/algolia.translations'
import { sourceTypeForProductsTracking } from '../../helpers/tracking'
import translations from '../../helpers/translations/cardSlider.translations'
import BlockTitle from '../private/BlockTitle'

export default {
  components: {
    RevButton,
    RevCardCarousel,
    BlockTitle,
    ProductThumb,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    blockPosition: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    productQueries: {
      type: Array,
      required: true,
    },
    ctaLink: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      products: [],
    }
  },
  async fetch() {
    const { ALGOLIA_ID, ALGOLIA_KEY } = this.$config
    const algoliaResult = await findResultsFromMultipleQueries({
      ALGOLIA_ID,
      ALGOLIA_KEY,
      queries: this.productQueries,
    })

    this.products = concatResultHits(algoliaResult, {
      getWarrantyByProduct: this.getWarrantyByProduct,
    })
  },
  computed: {
    translations: () => translations,
    hasProducts() {
      return !isEmpty(this.products)
    },

    hasCtaLink() {
      return !isEmpty(this.ctaLink)
    },

    sourceType() {
      const { name, params } = this.$route

      return sourceTypeForProductsTracking({
        blockPosition: this.blockPosition,
        pageName: params.pageName,
        routeName: name,
      })
    },
  },
  methods: {
    getWarrantyByProduct(product) {
      return this.$t(algoliaTranslations.warranty, {
        duration: product.warranty,
      })
    },

    sendTrackingProductClickData(product, index) {
      const trackingData = {
        widgetId: null,
        list: this.sourceType,
        product: {
          brand: product.brand,
          category: product.category_3,
          name: product.title,
          price: product.price,
          currency: product.currency,
          id: product.backmarketID,
          // TODO: URL-352 Use product.id when available in Algolia to get the UUID
          uuid: product.link.params.uuid,
          variant: product.backbox_grade_value,
          list: this.sourceType,
          position: index + 1,
          color: product.color,
          merchantId: product.merchant_id,
          model: product.title_model,
          dealType: PRODUCT_DEAL_TYPE.NORMAL,
          source: PRODUCT_SOURCE.SEARCH,
          listingId: product.objectID.toString(),
          shippingPrice: PRODUCT_DEFAULT_SHIPPING_COST,
          provider: PRODUCT_PROVIDERS.ALGOLIA,
        },
      }

      this.$emit('track-product-click', trackingData)
    },
  },
}
